import React from "react";
import { TableCellId } from "./TableCellId.jsx";
import HumanReadableDateTimeHover from "~/components/HumanReadableDateTimeHover.jsx";
import { humanReadableDate } from "rylak-common";

export function getTableHeadDateTime(props) {
    return {
        id: props?.id || "createdAt",
        label: props?.label || "Created",
        arrowsReversed: true,
        defaultSortDirection: "desc",
        ...props,
    };
}

export function TableCellDateTime({ dateTime, fontSize = "11px", contentFn, ...rest }) {
    return <TableCellId fontSize={fontSize} id={<HumanReadableDateTimeHover dateTime={dateTime} contentFn={contentFn} />} {...rest} />;
}

export function TableCellDateTimeShort({ ...rest }) {
    return <TableCellDateTime {...rest} contentFn={humanReadableDate} />;
}
